import {
  CREATE_NEW_RECORD,
  CREATE_NEW_RECORD_SUCCESS,
  CREATE_NEW_RECORD_ERROR,
  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  PANEL_NEW_RECORD_SHOW_CLICK,
  COMMENT_PANEL_SHOW_HIDE_CLICK,
  COMMENT_PANEL_SHOW_CLICK,
  COMMENT_PANEL_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
  EDIT_BUTTON_PRESSED,
  CREATE_BUTTON_PRESSED
} from "../actions";

export const createNewRecord = (newRecord, history,activityInfo) => ({
    type: CREATE_NEW_RECORD,
    payload: {newRecord, history, activityInfo}
  });

export const createNewRecordSuccess = (recordCreated) => ({
  type: CREATE_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createNewRecordError = (message) => ({
  type: CREATE_NEW_RECORD_ERROR,
  payload: { message },
});

export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const hideCommentPanel = () => ({
    type: COMMENT_PANEL_HIDE_CLICK,
    payload: {},
  });

export const showNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_CLICK,
    payload: {},
  });

export const showCommentPanel = () => ({
    type: COMMENT_PANEL_SHOW_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const toggleNewCommentPanel = () => ({
    type: COMMENT_PANEL_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });


export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});

export const editButtonPressed = () => ({
  type: EDIT_BUTTON_PRESSED,
  payload: {  }
});

export const createButtonPressed = () => ({
  type: CREATE_BUTTON_PRESSED,
  payload: {  }
});